import { IContentAdapterCasinoGamesInfoResponse } from "@sparkware/uc-sdk-core";
import {GameRawData} from "./services/sdk/gme-raw-data.type";

export const B2C_APP_ID: string = "B2C";


export interface IUserInfo {
    readonly isAuthorized: boolean;
}

export interface ISiteInfo {
    readonly brandId: number;
    readonly subBrandId: number;
}

export interface IClientInfo {
    readonly fullVersion: string;
}


export interface IOrbitApi {
    readonly version: string;
    readonly userInfo: IUserInfo;
    readonly siteInfo: ISiteInfo;
    readonly clientInfo: IClientInfo;

    deepLink(deepLinkObject: any, navigate?: any): any;

    bannerAdminDeepLink(action: string, id: string): any;

    getMarketingData(marketingParams): any;

    sendAnalytics(cat?, action?, label?, value?): void;

    showPwaPrompt(): any;

    isPwaInstallable(): any;

    subscribeOnAuthChange(callback: () => void): void;

    getGamesInfo(gameTypes: number[]): Promise<IContentAdapterCasinoGamesInfoResponse>;

    getGamesWithoutBonus(): Promise<GameRawData>;

    getRefreshToken(): string;
    printRestrictions(): void;
}
